import React from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { pipe } from "Utils/index";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { TagButton } from "ComponentsUI/Buttons";

const TagListContainer = (props) => {
	let generateTagUrl = (search) => {
		return generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: props.match.params.regionUrl,
			providerName: props.match.params.providerName,
			anchorUrl: search,
		});
	};

	let {
		ApplicationModel: { text },
		location: { search },
	} = props;

	const tagsList = [
		{
			name: text.RATING_FILTER_NAME.GOOD,
			url: generateTagUrl("?sort=useful"),
			search: "?sort=useful",
		},
		{
			name: text.RATING_FILTER_NAME.NEW,
			url: generateTagUrl(""),
			search: "",
		},
		{
			name: text.RATING_FILTER_NAME.OLD,
			url: generateTagUrl("?sort=old"),
			search: "?sort=old",
		},
	];

	return (
		<>
			{tagsList.map((tag) => {
				return (
					<TagButton
						key={tag.search}
						elem={tag}
						filterIsUrl={true}
						active={search === tag.search}
						anotherUrl={tag.url}
						isProviderReviews={props.isProviderReviews}
					/>
				);
			})}
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"), withRouter)(TagListContainer);
